module.exports = __webpack_public_path__ + "assets/img/22_1310.54367821.jpg";